<h1 class="page-title mb-5">المركز الإعلامي</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            الهيئة العامة للاستثمار والمناطق الحرة هي هيئة اقتصادية عامة لها
            شخصية اعتبارية عامة تنظم الاستثمار في الدولة وتشجعه وتدعمه وتديره
            وتروج له بما يحقق خطة التنمية الاقتصادية للدولة ، ولها أن تنشئ
            فروعاً لها. أو مكاتب داخل جمهورية مصر العربية أو في الخارج بقرار من
            مجلس الإدارة كجزء من بعثات التمثيل التجاري. ​​
          </p>
        </div>

        <ul class="links-nav-cont p-0 m-0" id="pills-tab" role="tablist">
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/mediaActions'" title="الأحداث">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/media/news.jpg"
                  onerror="this.src='assets/images/placeholder.jpg'" title="الأحداث" alt="الأحداث" />
              </div>
              <span>الأحداث</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/medianews'" title="الاخبار">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/media/events.jpg"
                  onerror="this.src='assets/images/placeholder.jpg'" title="الاخبار" alt="الاخبار" />
              </div>
              <span>الاخبار</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/mediaVideos'" title="معرض الفيديو">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/media/video.jpg"
                  onerror="this.src='assets/images/placeholder.jpg'" title="معرض الفيديو" alt="معرض الفيديو" />
              </div>
              <span>معرض الفيديو</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-3">
        <app-fix-media></app-fix-media>
      </div>
    </div>
  </div>
</div>